(function () {
  if (!document.body.classList.contains('template-page-baggy-caps')) return;

  const root = document.documentElement;
  let ticking = false;

  function measure() {
    ticking = false;
    const header = document.getElementById('shopify-section-header');
    if (!header) return;
    const rect = header.getBoundingClientRect();
    const gap = 12;
    const bottom = rect.bottom;
    const offset = bottom > 0 ? bottom + gap : Math.max(8, gap);
    root.style.setProperty('--baggy-caps-sticky-top', `${offset}px`);
  }

  function onFrame() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(measure);
    }
  }

  measure();
  window.addEventListener('load', onFrame);
  window.addEventListener('scroll', onFrame, { passive: true });
  window.addEventListener('resize', onFrame);

  const header = document.getElementById('shopify-section-header');
  if (header) {
    new MutationObserver(onFrame).observe(header, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }
})();
